module.exports = __webpack_public_path__ + "img/1.a5a81404.webp";